export const state = {
  account: null,
  accounts: []
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/account/state.js